<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <span>{{ topTitle }}</span>
        </div>
        <div class="exam-box" v-loading="loading">
          <div class="title">{{ topTitle }}</div>
          <div class="text_prc">
            <div class="text_prc_left">
              <div class="text_prc_left_title">{{ "总题数:" + planinfo.num }}</div>
              <div class="text_prc_left_title">{{ "及格分:" + planinfo.pass_score + "分" }}</div>

              <div class="text_prc_left_title">{{ "报名时间:" + timeToDate(planinfo.stime) + "至" + timeToDate(planinfo.etime) }}</div>
              <!-- <div class="text_prc_left_title">{{ '考试类型:'+ '在线考试' }}</div> -->
            </div>
            <div class="text_prc_left">
              <div class="text_prc_left_title">{{ "总时长:" + planinfo.times + "分钟" }}</div>
              <div class="text_prc_left_title">{{ "考试时间:" + timeToDate(planinfo.start_time) + "至" + timeToDate(planinfo.end_time) }}</div>
              <div class="text_prc_left_title">{{ "发布时间:" + timeToDate(planinfo.ctime) }}</div>
            </div>
          </div>

          <div class="tr-foot">
            <div class="btn buy-btn" v-if="status == 1" @click="nowPay()">{{ "报名缴费" }}</div>
            <div class="btn buy-btn" v-if="status == 2" :class="{ disabled: didTimeAround }" @click="toExam()">
              {{ didTimeAround ? tipContent : "进行考试" }}
            </div>
            <div class="btn buy-btn" v-if="status == 3" @click="toSee()">{{ "查看证书" }}</div>
            <div class="btn buy-btn" v-if="status == 4" :class="{ disabled: didTimeAround }" @click="toExamB()">
              {{ didTimeAround ? tipContent : "进行补考" }}
            </div>
            <div class="btn buy-btn" v-if="status == 10">{{ "暂无补考" }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 证书pop-->
    <el-dialog title="证书" :visible.sync="showPop" width="30%">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column; font-size: 16px">
        <img style="width: 100%; height: auto" :src="imageUrl" alt="" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showPop = false">取 消</el-button>
        <el-button type="primary" @click="downloadIamge(imageUrl, '证书')" :loading="load">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      load: false,
      imageUrl: "",
      showPop: false,
      loading: false,
      topTitle: "详情",
      examId: "",
      planinfo: {},
      order_id: "",
      status: 1,
      didTimeAround: false,
      tipContent: "",
      currentTime: null, //当前时间戳
    };
  },
  computed: {
    timeToDate() {
      return (time) => {
        var date = new Date(time * 1000); //如果date为13位不需要乘1000
        var Y = date.getFullYear() + "-";
        var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var s = ":" + date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m;
      };
    },
  },
  created() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        // 离开当前tab标签
      } else {
        // 回来
        this.init();
        this.getCurrentTime();
      }
    });
  },

  mounted() {
    this.loading = true;
    this.examId = this.$route.params.id;
    sessionStorage.setItem("nowPageData", JSON.stringify(this.examId));
    this.init();
    this.getCurrentTime();
  },
  methods: {
    init() {
      this.$api.orderInfo({ plan_id: this.examId, order_id: this.order_id }).then((res) => {
        if (res.status) {
          this.planinfo = res.data.planinfo;
          this.topTitle = res.data.planinfo.title;
          this.status = res.data.order.status;
          this.order_id = res.data.order.order_id;
          if (this.status == 2) {
            //去考试(报过名的)
            if (this.currentTime < res.data.planinfo.start_time && this.currentTime > res.data.planinfo.stime) {
              this.didTimeAround = true;
              this.tipContent = "考试未开始";
            } else if (this.currentTime > res.data.planinfo.end_time) {
              this.didTimeAround = true;
              this.tipContent = "考试已结束";
            }
            // // console.log(this.didTimeAround,this.tipContent);
          } else if (this.status == 4) {
            //去补考
            if (this.currentTime < res.data.planinfo.start_time) {
              this.didTimeAround = true;
              this.tipContent = "补考报名未开始";
            } else if (this.currentTime > res.data.planinfo.end_time) {
              this.didTimeAround = true;
              this.tipContent = "补考报名已结束";
            }
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.loading = false;
      });
      //   this.$api.examinaTopicList({ plan_id: this.examId }).then((res) => {
      //     if (res.status) {
      //       this.num = res.data.list.length;
      //       this.pass_score = res.data.pass_score;
      //     } else {
      //        this.$message({
      //         message: res.msg,
      //         type: "error",
      //       });
      //     }
      //   });
    },
    // 缴费
    nowPay() {
      let data = {
        plan_id: this.examId,
        payment_code: "wechatpay",
        make_up_exam: 2,
      };
      this.$api.examPay(data).then((res) => {
        if (res.status) {
          if (this.planinfo.price * 1) {
            this.$router.push({
              name: "gamePay",
              params: { order_id: res.data.order_id, type: 10, title: this.topTitle, project_id: this.examId },
            });
          } else {
            this.$message({
              message: "报名成功",
              type: "warning",
            });
            this.init();
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    toExam() {
      // this.$router.push({
      //   name: "startExam",
      //   params: { order_id: this.order_id, plan_id: this.examId,title: this.topTitle},
      // });

      if (!this.didTimeAround) {
        // console.log(`startExam_${this.examId}`,'1111');
        // return false
      
        if (!localStorage.getItem(`startExam_${this.examId}`)) {
          localStorage.setItem(`startExam_${this.examId}`, true);
          const { href } = this.$router.resolve({
            name: "startExam",
            params: { order_id: this.order_id, plan_id: this.examId, title: this.topTitle },
          });
          window.open(href, "_blank");
        }else{
          this.$message({
            message: "您已开始考试，请勿重复点击",
            type: "warning",
          });
        }
      }
    },
    // 进行补考
    toExamB() {
      if (!this.didTimeAround) {
        let data = {
          plan_id: this.examId,
          payment_code: "wechatpay",
          make_up_exam: 1,
        };
        this.$api.examPay(data).then((res) => {
          if (res.status) {
            if (this.planinfo.make_up_exam_price * 1) {
              this.$router.push({
                name: "gamePay",
                params: { order_id: res.data.order_id, type: 10, title: this.topTitle, projectId: this.examId, bk: true },
              });
            } else {
              this.$message({
                message: "报名成功",
                type: "warning",
              });
              this.init();
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    // 获取当前时间
    getCurrentTime() {
      let time = new Date();
      this.currentTime = time.getTime() / 1000;
    },
    // 查看证书
    toSee() {
      // this.$router({
      //     name: 'examCertificate',
      //     params: { plan_id: this.id}
      // })
      this.$api
        .certificate({
          plan_id: this.examId,
        })
        .then((res) => {
          if (res.status) {
            this.imageUrl = res.data;
            this.showPop = true;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    downloadIamge(imgsrc, name) {
      this.load = true;
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossorigin", "anonymous");

      // console.log("当前图片",image);
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
      this.load = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text_prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .text_prc_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: left;
      .text_prc_left_title {
        margin-bottom: 32px;
        height: 22px;
        padding-left: 100px;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
